import React, {memo, useEffect} from 'react'
import TimeAgo from 'react-timeago'
import {Breadcrumb, Button, Grid, Header, Table, Pagination} from 'semantic-ui-react'
import {withErrorHandling, withNavigation, withNotificationsData, withPropsPresent, withMeData} from '../../hoc'
import {goTo} from '../../util'
import {markNotificationViewed} from '../../backend'
import {useSafeState} from '../../hook'

const _Notifications = (
  {
    goTo,
    navigate,
    notifications,
    query,
    totalNotificationsCount,
    markNotificationViewed,
    mutateNotifications
  }) => {
  const [state, setState] = useSafeState({markingViewed: []})

  useEffect(() => {
    setState({...state, markingViewed: []})
  }, [notifications])

  let {activePage = '1'} = query
  activePage = parseInt(activePage)

  const getButtonText = (notification) => {
    return 'View'
  }

  const onPaginationChange = (e, {activePage}) => {
    navigate('/c/notifications', {query: {activePage}})
  }

  const onMarkRead = async (e, notification) => {
    e.preventDefault()
    setState({...state, markingViewed: [...state.markingViewed, notification.id]})
    await markNotificationViewed(notification.id)
    await mutateNotifications()
    navigate(notification.path)
  }

  const totalPageCount = totalNotificationsCount <= 10 ? 1 : Math.ceil(totalNotificationsCount / 10)

  return (
    <Grid divided='vertically'>
      <Grid.Row coloumns='16'>
        <Grid.Column width='16'>
          <Breadcrumb>
            <Breadcrumb.Section link
                                onClick={() => goTo(`${process.env.REACT_APP_SITE_URL}`)}>Home</Breadcrumb.Section>
            <Breadcrumb.Divider/>
            <Breadcrumb.Section link
                                onClick={() => navigate('/c/services')}>Console</Breadcrumb.Section>
            <Breadcrumb.Divider/>
            <Breadcrumb.Section active>Notifications</Breadcrumb.Section>
          </Breadcrumb>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width='16'>
          {
            notifications.length === 0 && (<div>No notifications found</div>)
          }
          {
            notifications.length > 0 && (
              <>
                <Header as='h2'>Notifications</Header>
                <Table striped collapsing>
                  <Table.Body>
                    {
                      notifications.map(n => (
                        <Table.Row key={n.id}>
                          <Table.Cell>{n.message}</Table.Cell>
                          <Table.Cell>
                            <TimeAgo date={n.createdAt} live={false}/>
                          </Table.Cell>
                          <Table.Cell>
                            <Button loading={state.markingViewed.includes(n.id)}
                                    onClick={(e) => onMarkRead(e, n)}>{getButtonText(n)}</Button>
                          </Table.Cell>
                        </Table.Row>
                      ))
                    }
                  </Table.Body>
                </Table>
                {
                  totalPageCount > 1 && (
                    <Pagination activePage={activePage} totalPages={totalPageCount}
                                onPageChange={onPaginationChange}></Pagination>
                  )
                }
              </>
            )
          }
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}

let Notifications = (props) => {
  const {handleError, notifications = []} = props
  if (notifications.length === 0) {
    props.navigate('/c/services')
    return null
  }
  props = {...props, goTo, markNotificationViewed: handleError(markNotificationViewed)}
  return (<_Notifications {...props}/>)
}

Notifications = withPropsPresent(Notifications, ['me', 'notifications'])
Notifications = withNotificationsData(Notifications)
Notifications = withMeData(Notifications)
Notifications = withNavigation(Notifications)
Notifications = withErrorHandling(Notifications)
Notifications = memo(Notifications)

export {_Notifications, Notifications}

export default Notifications